import React from "react";
import ArtistService from "../apis/artist";
import Pic from "./../pictures/picture2.png";
import {Link} from "react-router-dom";
import "./nav.css" 

class ArtistItem extends React.Component {

    state = {
        currentArtist: {}
    };

    componentDidMount() {
        this.fetchArtist();
    };
    async fetchArtist() {
        const response = await ArtistService.getArtist(this.props.artistId);
        this.setState({currentArtist: response.data});
    };
    render() {
        const profilePicture = "/pictures/" + this.state.currentArtist.profilePicture + ".png";
        return (
            <div className="container ui artist-item">
                <div className="ui items">
                    <div className="item">
                        <div className="image">
                            <img src={Pic}/>
                        </div>
                        <div className="content">
                            <a className="header"> 
                                <Link to={`/artist/${this.state.currentArtist.id}`}>
                                    {this.state.currentArtist.name}
                                </Link>
                            </a>
                            <div className="meta">
                            <span>{this.state.currentArtist.description}</span>
                            </div>
                            <div className="description">
                            <p></p>
                            </div>
                            <div className="extra">
                                <Link to={`/artist/${this.state.currentArtist.id}`}>
                                    Additional Details
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            );
    }

}
export default ArtistItem;